/*!
 Copyright 2015 Zalando SE

 Licensed under the Apache License, Version 2.0 (the "License");
 you may not use this file except in compliance with the License.
 You may obtain a copy of the License at

 http://www.apache.org/licenses/LICENSE-2.0

 Unless required by applicable law or agreed to in writing, software
 distributed under the License is distributed on an "AS IS" BASIS,
 WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 See the License for the specific language governing permissions and
 limitations under the License.
 */

'use strict';


function createSandbox(keys) {

    keys = keys || {};

    var PLACEHOLDER_REGEX = /\{(\d+)\}/g;

    /**
     * Replaces numbered placeholders in the string, e.g.
     *    translate.interpolate('Hello {0}, {1}!', ['Rob', 'Bob'])
     *    => 'Hello Rob, Bob!'
     * If `text` contains more placeholders than replacements given,
     * those placeholders are replaced with empty strings.
     * @param {string} text
     * @param {Array<string|array>} [replacements=[]]
     * @returns {string}
     */
    function interpolate(text, replacements) {
        replacements = replacements || [];
        var replacer = function (match, placeholderNumber) {
            return replacements[parseInt(placeholderNumber, 10)] || '';
        };
        return text.replace(PLACEHOLDER_REGEX, replacer);
    }

    /**
     * Tries to lookup a key in a internal storage, using empty string
     * if no translation is found and then uses arguments after the first
     * one (if present) for interpolating numbered placeholders.
     * @param {string} key
     * @param {...(string|number)} replacement_var_args
     * @returns {string}
     */
    function translate(key, replacement_var_args) { // eslint-disable-line
        if (translate.passThrough) {
            return key;
        }
        var replacements = [];
        // this ugly hack is to avoid function deoptimization in V8
        for (var i = 1; i < arguments.length; ++i) {
            replacements.push(arguments[i]);
        }
        var translation = keys.hasOwnProperty(key) ? keys[key] : '';
        return translate.interpolate(translation, replacements);
    }

    /**
     * Injects new translations to an internal map of key => translation
     * overriding previous translations for conflicting keys.
     * @param {object} newTranslations
     */
    function inject(newTranslations) {
        Object.assign(keys, newTranslations);
    }

    /**
     * Completely overrides previous translation map with a new one
     * @param {object} newTranslations
     */
    function replace(newTranslations) {
        keys = Object.assign({}, newTranslations);
    }

    translate.interpolate = interpolate;
    translate.inject = inject;
    translate.replace = replace;

    /**
     * Pass Through is used to show keys without attempting to translate them
     * @type {boolean}
     */
    translate.passThrough = false;

    return translate;
}

var globalSandbox = createSandbox();
globalSandbox.createSandbox = createSandbox;

module.exports = globalSandbox;



//////////////////
// WEBPACK FOOTER
// ./~/tranzlate/index.js
// module id = 374
// module chunks = 0